module.exports = __webpack_public_path__ + "static/media/garagescript-chat.a1008d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/garagescript-chat.png
// module id = 477
// module chunks = 0